export default {
  methods: {
    createHeadlineId(string) {
      return this.createId(string, "h");
    },

    createId(string, context = "") {
      return `aid_${context}_` + string.replace(/\W/g, "");
    }
  }
};